// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2iYSI","amount":"Amount_amount__30qGo","tip":"Amount_tip__pop7Q","tipHeader":"Amount_tipHeader__1CuEY","tipsWrap":"Amount_tipsWrap__1JOZ6"};